import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  swiper: 'data-media-swiper',
  content: 'data-slide-content',
}
const qsAll = {
  sections: 'data-section-type="gallery"',
}

const initSection = (section) => {
  new Swiper(section.querySelector(`[${qs.swiper}]`), {
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      // when window width is >= 480px
      768: {
        slidesPerView: "auto",
        spaceBetween: 20,
      },
    },
  })
  Fancybox.bind('[data-fancybox="gallery-item"]', {
    Toolbar: {
      // items: {
      //   prev: {
      //     tpl: '<button class="f-button !fixed !top-1/2 !-translate-y-1/2 !left-3 lg:!left-6" title="{{PREV}}" data-fancybox-prev><svg class="!rotate-180 w-5 h-4" xmlns="http://www.w3.org/2000/svg" width="17" height="8" viewBox="0 0 17 8" fill="none"><path d="M0 4H14" stroke="currentColor" stroke-width="1.5"/><path d="M9 1L15 4L9 7" stroke="currentColor" stroke-width="1.5"/></svg></button>',
      //   },
      //   next: {
      //     tpl: '<button class="f-button !fixed !top-1/2 !-translate-y-1/2 !right-3 lg:!right-6" title="{{NEXT}}" data-fancybox-next><svg class="w-5 h-4" xmlns="http://www.w3.org/2000/svg" width="17" height="8" viewBox="0 0 17 8" fill="none"><path d="M0 4H14" stroke="currentColor" stroke-width="1.5"/><path d="M9 1L15 4L9 7" stroke="currentColor" stroke-width="1.5"/></svg></button>',
      //   },
      // },
      display: {
        left: [],
        middle:  [
          // "prev", "next"
        ],
        right: ["close"],
      },
    },
    Thumbs: false,
    on: {
      done: (fancybox, slide) => {
        const s = fancybox.getSlide()
        if(s && s.el) {
          const content = s.el.querySelector(`[${qs.content}]`)
          if(content && content.querySelector('[data-content-image]')) {
            content.style.width = `${content.querySelector('[data-content-image]').offsetWidth}px`
          }
        }
      },
      resize: (fancybox, slide) => {
        const s = fancybox.getSlide()
        if(s && s.el) {
          const content = s.el.querySelector(`[${qs.content}]`)
          if(content && content.querySelector('[data-content-image]')) {
            content.style.width = ''
            content.style.width = `${content.querySelector('[data-content-image]').offsetWidth}px`
          }
        }
      },
    },
  })
}

export const setupGalleries = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach(section => initSection(section))
}